import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=4aa63827&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=ts"
export * from "./ClientView.vue?vue&type=script&lang=ts"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=4aa63827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa63827",
  null
  
)

export default component.exports